export {Playlists as Page};

import {useEffect, useState} from "preact/hooks";
import {Playlist} from "../../components/Playlist.jsx";
import messages from "../../messages/messages.js";
import API_URL from "../../includes/api.js";
import {Helmet} from "react-helmet-async";
import {useLocation} from "../../hooks/useLocation.js";
import {usePageContext} from "../../hooks/usePageContext.js";

function Playlists() {

    // Seeded from +data.shared.js's server-side fetch so the grid is populated
    // before the client-side fetch below completes after hydration.
    const seededPlaylists = usePageContext()?.data?.playlists ?? null;

    const [playlists, setPlaylists] = useState(seededPlaylists ?? []);
    const [initialPlaylists, setInitialPlaylists] = useState(seededPlaylists ?? []);
    const [sortOption, setSortOption] = useState('');

    const location = useLocation();

    useEffect(() => {
        if (seededPlaylists) return;

        fetch(`${API_URL}/playlist/all`)
            .then(response => response.json())
            .then(data => {
                if (data.code === 200) {
                    setInitialPlaylists(data.data);
                    setPlaylists(data.data);
                }
            });
    }, []);

    useEffect(() => {
        if (!sortOption) {
            setPlaylists(initialPlaylists);
            return;
        }

        const sorted = [...initialPlaylists].sort((a, b) =>
            sortOption === 'ASC'
                ? a.category_name.localeCompare(b.category_name)
                : b.category_name.localeCompare(a.category_name)
        );
        setPlaylists(sorted);
    }, [sortOption, initialPlaylists]);

    return (
        <section className="text-white">

            <Helmet>
                <title>{messages["META.PLAYLISTS.TITLE"]}</title>
                <meta name="description" content={messages["META.PLAYLISTS.DESC"]}/>
            </Helmet>

            <div>
                <div className="grid md:grid-cols-2 gap-6">
                    <div>
                        <h1>Exclusive {messages["SITE.NAME"]} Playlists</h1>
                        <p>Discover our exclusive playlists for a mesmerizing audio experience. Unwind
                            and set the mood with our carefully curated collection</p>
                    </div>
                    <div className="mb-4 flex md:justify-end items-end">
                        <label htmlFor="sortOption" className="mr-2">Sort by:</label>
                        <select
                            id="sortOption"
                            value={sortOption}
                            onChange={(e) => setSortOption(e.target.value)}
                            className="px-2 py-1 rounded-lg bg-neutral-800 text-white cursor-pointer">
                            <option value="">Popular</option>
                            <option value="ASC">A-Z</option>
                            <option value="DESC">Z-A</option>
                        </select>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-5 mb-8 min-h-80">
                    {playlists.map((playlist) => (
                        <Playlist playlist={playlist} location={location}/>
                    ))}
                </div>

                <p dangerouslySetInnerHTML={{__html: messages["PLAYLISTS.DESC"]}}></p>
            </div>
        </section>
    );
}
